import styled from 'styled-components';

const Container = styled.div`
  box-sizing: border-box;
  overflow: overlay;
  max-height: calc(100vh - 80px);
  padding: 40px 20px;
  background-color: ${props => props.theme.color.background};
  border-radius: 40px;

  &::-webkit-scrollbar-track {
    margin: 25px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: ${p => p.theme.color.turquoiseFontDay};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${p => p.theme.color.gray};
  }
`;

export const Styled = {
  Container,
};
